window.addEventListener('DOMContentLoaded', (event) => {
  const brands = document.querySelectorAll('.brand-list');
  const searchBrands = document.getElementById('brand-search');
  const modal = document.querySelector('.brand-modal');

  handleBrandSearch();

  function handleBrandSearch() {
    if (searchBrands && brands.length == 0) return;



    searchBrands.addEventListener('input', (e) => {
      let currentCount = 0;

      if (e.target.value.length > 0) {
        const targetValueLowercase = e.target.value.toLowerCase();

        brands.forEach((brand) => {
          const brandItems = brand.querySelectorAll('li');

          const returnO = [...brandItems].filter((item) => {
            const brandName = item.dataset.brand;
            const brandNameLowerCase = brandName.toLowerCase();

            if (!brandNameLowerCase.includes(targetValueLowercase)) {
              item.firstElementChild.innerHTML = brandName;
              item.style.display = 'none';
              return false;
            }

            const indexFound = brandNameLowerCase.indexOf(targetValueLowercase);
            const indexEnd = indexFound + targetValueLowercase.length;
            const output = [brandName.slice(0, indexFound), '<u><strong>', brandName.slice(indexFound, indexEnd), '</strong></u>', brandName.slice(indexEnd)].join('');

            item.firstElementChild.innerHTML = output;
            item.style.display = 'block';

            return true;
          });

          if (returnO.length > 0) {
            currentCount += returnO.length;
            brand.style.display = 'block';
          } else {
            currentCount === 0 ? 0 : currentCount - 1;
            brand.style.display = 'none';
          }
        });
      } else {
        brands.forEach((brand) => [brand, ...brand.querySelectorAll('li')].forEach((ele) => {
          ele.style.display = 'block';

          if (ele.dataset.brand) {
            ele.firstElementChild.innerHTML = ele.dataset.brand;
          }
        }));

        currentCount = -1;
      }

      handleEmpty(currentCount);
    });
  }


  function handleEmpty(count) {
    if (count == -1) {
      modal.innerHTML = '';
      return;
    }

    const modalHTML = count === 1 ? `${count} matching result` : `${count} matching results`;
    modal.innerHTML = `<p class="mt-xl">${modalHTML}</p>`;
  }

});
